import React from "react";

import Editor from './ABridCompareWithLinkEditor'
import EditorWrapper from '../../EditorWrapper'

import BridCompareWithLink from "../../common/BridCompareWithLink";
import EmptyArticle from "../../common/EmptyArticle";

const ABridCompareWithLink = props => {
    let article = EmptyArticle();
    const { settings } = props;
    const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

    article.title = settings.title_normal;
    article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
    article.url = settings.link;
    article.label = settings.label;
    article.articleID = settings.articleID;
    article.link = settings.link_article;

    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridCompareWithLink
                article={article}
                size={props.size}
                imageHeight={props.imageHeight}
                preserveImageRatio={props.preserveImageRatio}
                secondArticleID={props.secondArticleID}
                thirdArticleID={props.thirdArticleID}
                {...props}
            />
        </div>
    );
};

export default ABridCompareWithLink;